import React from 'react';
import './Cartephotos.css';
import mairietec2 from '../../Images/mairietec2.jpg';
import mairietec3  from '../../Images/mairietec3.jpg';
import mairietec4 from '../../Images/mairietec4.jpg';
import mairietec5 from '../../Images/mairietec5.jpg';
import mairietec6 from '../../Images/mairietec6.jpg';
import mairietec from '../../Images/mairietec.jpg'
import mairietec7 from '../../Images/mairietec7.jpg';
import mairietec8 from '../../Images/mairietec8.jpg';
import mairietec9 from '../../Images/mairietec9.jpg';
import mairietec10 from '../../Images/mairietec10.jpg';
import mairietec11 from '../../Images/mairietec11.jpg';
import mairietec12 from '../../Images/mairietec12.jpg';
import mairietec13 from '../../Images/mairietec13.jpg';
import mairietec14 from '../../Images/mairietec14.jpg';
import mairietec15 from '../../Images/mairietec15.jpg';

const Cartephotos = () => {
    return (
        <div className="Cartephotos-container">
            <div className='container12'>
                <div className='barre24'>
                    <div className='trait34s'></div>
                    <div className='trait44s'></div>
                   
                </div>
            </div>

            <div className="cards1-container2">
                <div className="card1">

                    <img src={mairietec2} alt="" />
                </div>

                <div className="card2">
                    <img src={mairietec3} alt="" />
                </div>

                <div className="card2">
                    <img src={mairietec4} alt="" />
                </div>

                <div className="card2">
                    <img src={mairietec6} alt="" />
                </div>

                <div className="card2">
                    <img src={mairietec5} alt="" />
                </div>

                <div className="card2">
                    <img src={mairietec7} alt="" />
                </div>

                <div className="card2">
                    <img src={mairietec8} alt="" />
                </div>
                 
                <div className="card2">
                    <img src={mairietec9} alt="" />
                </div>

                <div className="card2">
                    <img src={mairietec10} alt="" />
                </div>
                
                <div className="card2">
                    <img src={mairietec11} alt="" />
                </div>
                 
                <div className="card2">
                    <img src={mairietec12} alt="" />
                </div>
                  
                <div className="card2">
                    <img src={mairietec13} alt="" />
                </div>
                   
                <div className="card2">
                    <img src={mairietec14} alt="" />
                </div>
                     
                <div className="card2">
                    <img src={mairietec15} alt="" />
                </div>  

                <div className="card2">
                    <img src={mairietec} alt="" />
                </div>


            </div>
        </div>
        

    );
};

export default Cartephotos;